import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";
import { API_GET_REAL_ESTATE_INVESTMENT_PORTFOLIO } from "../../../config/api";
import mixpanel from "mixpanel-browser";

export const getRealEstatePortfolio = createAsyncThunk(
  "getRealEstatePortfolio/getList",
  async ({ currency, cb }, { rejectWithValue }) => {
    try {
      const { data } = await Client({
        method: "GET",
        path: `${API_GET_REAL_ESTATE_INVESTMENT_PORTFOLIO}/${currency}`,
      });

      if (cb) cb();
      return data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      // mixpanel.track("Error", {
      //   type: "portfolio",
      //   subtype: "get-my-portfolio",
      //   message: msg,
      // });
      if (cb) cb();
      // toast.error(msg);
      throw error;
    }
  }
);
